import React from 'react';

const AttentionIcon = ({
    color = '#EDA210',
    size = 18,
}: {
    color?: string;
    size?: number;
}): JSX.Element => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.99996 15.6667C12.6815 15.6667 15.6666 12.6816 15.6666 8.99999C15.6666 5.31841 12.6815 2.33332 8.99996 2.33332C5.31838 2.33332 2.33329 5.31841 2.33329 8.99999C2.33329 12.6816 5.31838 15.6667 8.99996 15.6667ZM8.99996 17.3333C4.39791 17.3333 0.666626 13.602 0.666626 8.99999C0.666626 4.39794 4.39791 0.666656 8.99996 0.666656C13.602 0.666656 17.3333 4.39794 17.3333 8.99999C17.3333 13.602 13.602 17.3333 8.99996 17.3333Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.16663 13.1667C8.16663 12.7064 8.53972 12.3333 8.99996 12.3333C9.4602 12.3333 9.83329 12.7064 9.83329 13.1667C9.83329 13.6269 9.4602 14 8.99996 14C8.53972 14 8.16663 13.6269 8.16663 13.1667Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.16663 4.83332C8.16663 4.37309 8.53972 3.99999 8.99996 3.99999C9.4602 3.99999 9.83329 4.37309 9.83329 4.83332V10.6667C9.83329 11.1269 9.4602 11.5 8.99996 11.5C8.53972 11.5 8.16663 11.1269 8.16663 10.6667V4.83332Z"
            fill={color}
        />
    </svg>
);

export default AttentionIcon;
